import { render } from "./strategies.vue?vue&type=template&id=98f0c48a"
import script from "./strategies.js?vue&type=script&lang=js&external"
export * from "./strategies.js?vue&type=script&lang=js&external"

import "./strategies.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__